import React from 'react';
import styled from 'styled-components';
import { EmailSent } from '@hox/ui/EmailSent';
import { Heading3, Paragraph } from '@hox/ui/Typography';
import { FormattedMessage } from 'react-intl';

// TODO: make a view out of this

const MagicLinkSentStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  > * {
    margin-bottom: 1.5rem;
    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const MagicLinkSent = () => (
  <MagicLinkSentStyled>
    <EmailSent />
    <Heading3>
      <FormattedMessage
        id="auth.login.magicLink.sentTitle"
        defaultMessage="Great!"
        description="On after sending magic link, we show a card with title"
      />
    </Heading3>
    <Paragraph>
      <FormattedMessage
        id="auth.login.magicLink.sentParagraph"
        defaultMessage="The Magic Link is on its way! Please check your email."
        description="Tell users where to find the magic link after we send it. Magic link let's users log in to the service"
      />
    </Paragraph>
  </MagicLinkSentStyled>
);
